import { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'
import {
  closedWidth as navRailWidth,
  closedWidthWide as navRailWidthWide,
} from '@editor/components/ProcessNavigation/styles'

interface Props {
  children: ReactNode
  /** How far the overlay reaches under the nav rail (to hide content's own left gutter). */
  railUnderlap?: number
  'data-cy'?: string
}

/**
 * Covers the plan view's scene pane right of the nav rail (e.g. with the PDF preview). The scene
 * stays mounted underneath, so removing the overlay restores it without reloading.
 */
const PlanViewSceneOverlay = ({
  children,
  railUnderlap = 0,
  'data-cy': dataCy,
}: Props): ReactElement => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      // The left nav rail overlays the scene pane; keep it visible next to the overlay.
      left: navRailWidth - railUnderlap,
      '@media (min-width: 1920px)': { left: navRailWidthWide - railUnderlap },
      // Above the scene (SceneControlled is its own stacking context, so nothing inside it can
      // rise above this), but below the nav rail: it has the same z-index and comes later in
      // the DOM.
      zIndex: 1,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'common.white',
    }}
    data-cy={dataCy}
  >
    {children}
  </Box>
)

export default PlanViewSceneOverlay
